import React, { Component } from 'react'
import { connect } from 'react-redux'

import { Row, Col } from 'react-bootstrap'
import DatePicker from 'material-ui/DatePicker'
import RaisedButton from 'material-ui/RaisedButton'
import TextField from 'material-ui/TextField'
import Checkbox from 'material-ui/Checkbox'
import Dialog from 'material-ui/Dialog'
import { Grid } from "@material-ui/core";

import Snackbar from 'material-ui/Snackbar'

import {
  getFailedMessagesReport,
  getMessagesReport,
  getLoginsReport,
  getContactsReport,
} from '../../reducers/daily-report/resources'
import { setSelectedCompany } from '../../reducers/company/actions'
import { getAllCompanies } from '../../reducers/company/resources';

import config from '../../config'
import moment from 'moment'
import mixpanel from '../../utils/mixpanel'
import Divider from 'material-ui/Divider'

class Reporting extends Component {
  componentWillMount() {
    this.setState({
      failedMessagesStartDate: undefined,
      failedMessagesEndDate: undefined,
      messagesStartDate: undefined,
      messagesEndDate: undefined,
      authStartDate: undefined,
      authEndDate: undefined,
      showSnackBar: false,
      contactStartDate: undefined,
      contactEndDate: undefined,
      companyNames: "",
      snackBarMessage:
        'End-date should be later than the start-date',
      checked: false,
      openCompanyListModal: false,
      allCheckBox: false,
    });

    getAllCompanies().then(({data: companyList}) => {
      if (companyList) {
        let state = this.state
        state.companyList = companyList
        this.setState(state)
      }
    });
  }

  handleOnChange = (type, date) => {
    this.setState({
      [type]: date,
    })
  }

  exportFailedMessagesReport = async ()=>{
    const { failedMessagesStartDate, failedMessagesEndDate } = this.state

    if (new Date(failedMessagesEndDate) < new Date(failedMessagesStartDate)) {
      this.setState({
        showSnackBar: true,
      })
      return
    }

    mixpanel.track(
      'export: failed message report',
      {
        data: {
          startdate: moment(failedMessagesStartDate).format('YYYY-MM-DD'),
          endDate: moment(failedMessagesEndDate).format('YYYY-MM-DD')
        }
      }
    )

    const response = await getFailedMessagesReport(
      moment(failedMessagesStartDate).format('YYYY-MM-DD'),
      moment(failedMessagesEndDate).format('YYYY-MM-DD'),
      this.props.selectedCompany,
    )
    const { fileName } = response.data
    window.location = `${config.api.host}/api/v1/files/failed-msgs-report/${fileName}`

  }

  exportMessagesReport = async () => {
    const { messagesStartDate, messagesEndDate } = this.state

    if (new Date(messagesEndDate) < new Date(messagesStartDate)) {
      this.setState({
        showSnackBar: true,
      })
      return
    }

    mixpanel.track(
      'export:message report',
      {
        data: {
          startdate: moment(messagesStartDate).format('YYYY-MM-DD'),
          endDate: moment(messagesEndDate).format('YYYY-MM-DD')
        }
      }
    )

    const response = await getMessagesReport(
      moment(messagesStartDate).format('YYYY-MM-DD'),
      moment(messagesEndDate).format('YYYY-MM-DD'),
      this.props.selectedCompany,
    )
    const { fileName } = response.data
    window.location = `${config.api.host}/api/v1/files/daily-report/${fileName}`
  }

  exportLoginsReport = async () => {
    const { authStartDate, authEndDate } = this.state

    if (new Date(authEndDate) < new Date(authStartDate)) {
      this.setState({
        showSnackBar: true,
      })
      return
    }

    mixpanel.track(
      'export:login report',
      {
        data: {
          startdate: moment(authStartDate).format('YYYY-MM-DD'),
          endDate: moment(authEndDate).format('YYYY-MM-DD')
        }
      }
    )

    const response = await getLoginsReport(
      moment(authStartDate).format('YYYY-MM-DD'),
      moment(authEndDate).format('YYYY-MM-DD'),
    )
    const { fileName } = response.data
    window.location = `${config.api.host}/api/v1/files/logins-report/${fileName}`
  }

  exportContactReport = async () => {
    const { contactStartDate, contactEndDate, companyNames, checked } = this.state;

    let formattedCompanyNames = "";

    if (new Date(contactEndDate) < new Date(contactStartDate)) {
      this.setState({
        showSnackBar: true,
      });
      return;
    }

    mixpanel.track(
      'export:contact report',
      {
        data: {
          startdate: moment(contactStartDate).format('YYYY-MM-DD'),
          endDate: moment(contactEndDate).format('YYYY-MM-DD')
        }
      }
    );

    // turn contactId list into '["999-1421212-01231-123","2812-412412-51512-321", ...]'
    if (companyNames) {
      formattedCompanyNames = `[${companyNames.split(',').map(item => `"${item.trim()}"`).toString()}]`;
    }

    const response = await getContactsReport(
      moment(contactStartDate).format('YYYY-MM-DD'),
      moment(contactEndDate).format('YYYY-MM-DD'),
      formattedCompanyNames,
      checked
    );

    const {fileName} = response.data;
    window.location = `${config.api.host}/api/v1/files/contacts-report/${fileName}`;
  }

  handleDisableFutureDays = (date) => {
    return Date.now() < Date.parse(date)
  }

  updateCheck() {
    getAllCompanies(!this.state.checked).then(({data: companyList}) => {
      if (companyList) {
        let state = this.state
        state.companyList = companyList
        state.checked = !state.checked
        this.setState(state)
      }
    });
  }

  updateCompanyCheck = (id) => {
    let { companyList, allCheckBox } = this.state;
    companyList.forEach((company, index) => {
      if(company.id == id) {
        if(company.isChecked) {
          companyList[index] = { ...company, isChecked: !company.isChecked }
        } else {
          companyList[index] = { ...company, isChecked: true }
        }
      }
    });

    // untoggle allCheckBox also
    this.setState({ companyList, allCheckBox: false });
  }

  handleCloseModal = () => {
    this.setState({
      openCompanyListModal: false
    });
  }

  handleOpenModal = () => {
    this.setState({
      openCompanyListModal: true
    });
  }

  handleCheckAll = () => {
    this.setState({
      allCheckBox: !this.state.allCheckBox,
      companyList: this.state.companyList.map((company) => {
        return {...company, isChecked: !this.state.allCheckBox}
      }),
    });
  }
  

  render() {
    const {
      failedMessagesStartDate,
      failedMessagesEndDate,
      messagesStartDate,
      messagesEndDate,
      authStartDate,
      authEndDate,
      contactStartDate,
      contactEndDate,
      companyNames,
      companyList,
    } = this.state

    const companyCheckBoxes = (companyList || [])
      .map((company, index) => {
        return (
          <Checkbox
            id={company.id}
            label={company.name}
            checked={company.isChecked}
            onCheck={() => { this.updateCompanyCheck(company.id) }}
          />
        )
      })

    const actions = [
      <RaisedButton
        label="Submit"
        primary={true}
        onClick={() => {
          let companyNames = [];

          this.state.companyList.forEach((company) => {
            if(company.isChecked) companyNames.push(company.name)
          })

          this.setState({
            companyNames: companyNames.join(', ')
          })
          this.handleCloseModal();
        }}
      />,
    ];



    return (
      <Grid fluid className="sitewide-grid-container">
        <Snackbar
          open={this.state.showSnackBar}
          message={this.state.snackBarMessage}
          autoHideDuration={3000}
        />
        <div>
          <div className="sitewide-title-wrapper">
            <div className="sitewide-title-container">
              <h2>Reporting</h2>
            </div>
          </div>
          <div className="sitewide-page-wrapper">
            <div className="sitewide-page-container">
            <Row className="sitewide-card m-0">
                <h3 style={{ marginBottom: '2.5rem' }}>
                  Export failed messages report
                </h3>
                <Row style={{ paddingLeft: '18px' }}>
                  <Col
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      width: '670px',
                      maxWidth: '670px',
                    }}
                  >
                    <DatePicker
                      hintText="Select Start Date"
                      onChange={(_, e) => this.handleOnChange('failedMessagesStartDate', e)}
                      value={failedMessagesStartDate}
                      shouldDisableDate={this.handleDisableFutureDays}
                    />
                    to
                    <DatePicker
                      hintText="Select End Date"
                      onChange={(_, e) => this.handleOnChange('failedMessagesEndDate', e)}
                      value={failedMessagesEndDate}
                      shouldDisableDate={this.handleDisableFutureDays}
                    />
                    <RaisedButton
                      label="Export"
                      primary={true}
                      onClick={this.exportFailedMessagesReport}
                      disabled={!failedMessagesStartDate || !failedMessagesEndDate}
                    />
                  </Col>
                </Row>
              </Row>
              
              
              
              <Row className="sitewide-card m-0 mt-30">
                <h3 style={{ marginBottom: '2.5rem' }}>
                  Export inbound and outbound messages report
                </h3>
                <Row style={{ paddingLeft: '18px' }}>
                  <Col
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      width: '670px',
                      maxWidth: '670px',
                    }}
                  >
                    <DatePicker
                      hintText="Select Start Date"
                      onChange={(_, e) => this.handleOnChange('messagesStartDate', e)}
                      value={messagesStartDate}
                      shouldDisableDate={this.handleDisableFutureDays}
                    />
                    to
                    <DatePicker
                      hintText="Select End Date"
                      onChange={(_, e) => this.handleOnChange('messagesEndDate', e)}
                      value={messagesEndDate}
                      shouldDisableDate={this.handleDisableFutureDays}
                    />
                    <RaisedButton
                      label="Export"
                      primary={true}
                      onClick={this.exportMessagesReport}
                      disabled={!messagesStartDate || !messagesEndDate}
                    />
                  </Col>
                </Row>
              </Row>
              <Row className="sitewide-card m-0 mt-30">
                <h3 style={{ marginBottom: '2.5rem' }}>Export logins report</h3>
                <Row style={{ paddingLeft: '18px' }}>
                  <Col
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      width: '670px',
                      maxWidth: '670px',
                    }}
                  >
                    <DatePicker
                      hintText="Select Start Date"
                      onChange={(_, e) => this.handleOnChange('authStartDate', e)}
                      value={authStartDate}
                      shouldDisableDate={this.handleDisableFutureDays}
                    />
                    to
                    <DatePicker
                      hintText="Select End Date"
                      onChange={(_, e) => this.handleOnChange('authEndDate', e)}
                      value={authEndDate}
                      shouldDisableDate={this.handleDisableFutureDays}
                    />
                    <RaisedButton
                      label="Export"
                      primary={true}
                      onClick={this.exportLoginsReport}
                      disabled={!authStartDate || !authEndDate}
                    />
                  </Col>
                </Row>
              </Row>
              <Row className="sitewide-card m-0 mt-30">
                <h3 style={{ marginBottom: '2.5rem' }}>Export contact report</h3>
                <Row style={{ paddingLeft: '18px' }}>
                  <Col
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      width: '570px',
                      maxWidth: '570px',
                    }}
                  >
                    <TextField
                      hintText="Enumerate Company Names to Include"
                      fullWidth={true}
                      multiLine={true}
                      rows="1"
                      rowsMax="5"
                      value={companyNames}
                      style={{ paddingRight: '14px' }}
                      onChange={(_, e) => this.handleOnChange('companyNames', e)}
                    />
                  </Col>
                </Row>
                <Row style={{ paddingLeft: '18px' }}>
                  <Col
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      width: '570px',
                      maxWidth: '570px',
                    }}
                  >
                    <DatePicker
                      hintText="Select Start Date"
                      onChange={(_, e) => this.handleOnChange('contactStartDate', e)}
                      value={contactStartDate}
                      shouldDisableDate={this.handleDisableFutureDays}
                    />
                    to
                    <DatePicker
                      hintText="Select End Date"
                      onChange={(_, e) => this.handleOnChange('contactEndDate', e)}
                      value={contactEndDate}
                      shouldDisableDate={this.handleDisableFutureDays}
                    />
                  </Col>
                </Row>
                <Row style={{ paddingLeft: '18px', marginTop: '12px' }}>
                  <Col xs={12} style={{ paddingLeft: '0px' }}>
                    <Checkbox
                      label="Include Inactive"
                      checked={!this.state.checked}
                      onCheck={() => { this.updateCheck() }}
                      style={{ width: '30%', display: 'inline-block' }}
                      labelStyle={{
                        color: 'rgba(0,0,0,0.8)',
                        lineHeight: '22px',
                      }}
                    />
                  </Col>
                  <Col
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      justifyContent: 'flex-end',
                      gap: '10px',
                      width: '570px',
                      maxWidth: '570px',
                    }}
                  >
                    <RaisedButton
                      label="List Companies"
                      primary={true}
                      onClick={() => { this.handleOpenModal() }}
                    />
                    <RaisedButton
                      label="Export"
                      primary={true}
                      onClick={this.exportContactReport}
                      disabled={!contactStartDate || !contactEndDate}
                    />
                  </Col>
                </Row>
              </Row>
            </div>
          </div>
        </div>
        <Dialog
          title="Select companies"
          actions={actions}
          modal={false}
          open={this.state.openCompanyListModal}
          onRequestClose={() => { this.handleCloseModal() }}
          autoScrollBodyContent={true}
        >
          <Checkbox
            id='checkbox'
            label={"Select All"}
            checked={this.state.allCheckBox}
            onCheck={() => { this.handleCheckAll() }}
            style={{ marginTop: '14px' }}
          />
          <Divider style={{ marginTop: '14px', marginBottom: '14px' }}/>
          {companyCheckBoxes}
        </Dialog>
      </Grid>
    )
  }
}

const mapStateToProps = (state) => {
    const { company: { selectedCompany } } = state;
    return { selectedCompany }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setSelectedCompany(data) {
            dispatch(setSelectedCompany(data))
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Reporting)
